export default "__VITE_ASSET__uMLnI9Fz__"